import { Modal } from '@finbeat/react-toolkit';
import { OrderInfoProvider, useOrderInfoContext } from 'providers/OrderInfoProvider';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { useOrderWorkplaceState } from './Order';
import ControlButtons from './OrderInfo/Additions/ControlButtons';
import OrderInfo from './OrderInfo/OrderInfo';
import OrderUnsavedChangesConfirm from './OrderUnsavedChangesConfirm';

type OrderChangeModalProps = {
    isOpen: boolean;
    toggle: () => void;
};

const OrderChangeModal = (props: OrderChangeModalProps) => {
    const { currentItem } = useOrderWorkplaceState();
    return (
        <OrderInfoProvider orderDetails={currentItem} onSubmitOrderSuccess={props.toggle}>
            <ModalForm {...props} />
        </OrderInfoProvider>
    );
};

const ModalForm = ({ isOpen, toggle }: OrderChangeModalProps) => {
    const className = 'order-change-modal';
    const { t } = useTranslation();
    const modalRef = useRef(null);
    const { orderDetails, isDirty, checksTabFormRef } = useOrderInfoContext();
    const [isOpenNotify, setOpenNotify] = useState(false);

    const toggleModal = (dirty?: boolean) => {
        dirty ? setOpenNotify((prev) => !prev) : toggle();
    };

    return orderDetails ? (
        <Modal
            size="xl"
            isOpen={isOpen}
            toggle={() => toggleModal(isDirty)}
            innerRef={modalRef}
            scrollable
        >
            <ModalHeader toggle={() => toggleModal(isDirty)}>
                {`${t('BackOfficeOrder')}`}
                {` #${orderDetails?.id}`}
            </ModalHeader>

            <ModalBody className={`${className}__body`}>
                <OrderInfo isModal generalInfo={orderDetails} modalRef={modalRef} />
            </ModalBody>
            <ModalFooter className="modal-footer justify-content-between">
                <ControlButtons
                    onNextSubmit={() => {
                        checksTabFormRef.current?.requestSubmit();
                    }}
                    info={orderDetails}
                    cancelAction={toggleModal}
                />
            </ModalFooter>
            <OrderUnsavedChangesConfirm
                isOpen={isOpenNotify}
                closeNotify={() => setOpenNotify(false)}
                closeWindow={toggle}
            />
        </Modal>
    ) : (
        <></>
    );
};

export default OrderChangeModal;
